import { ComponentType } from '@angular/cdk/overlay';
import { Component } from '@angular/core';
import { ISidenavItemDescriptor, ISidenavItemProvider } from 'core';
import { SidenavItem } from 'design-system';

@Component({
  selector: 'app-base-sidenav-item',
  imports: [
    SidenavItem
  ],
  templateUrl: './base-sidenav-item.component.html',
  styleUrl: './base-sidenav-item.component.scss'
})
export class BaseSidenavItemComponent extends ISidenavItemProvider {
  
  override describe(): ISidenavItemDescriptor {
    return { providerName: '' };
  }

  override evaluate(): ComponentType<any> {
    return BaseSidenavItemComponent;
  }

}
